<template>
  <!-- 创建账号 -->
  <el-dialog
    width="700px"
    :show-close="false"
    :visible.sync="visible"
    destroy-on-close
    @close="closeDia"
    :close-on-click-modal="false"
  >
    <div class="create-account">
      <p @click="visible=false"><i class="el-icon-arrow-left" style="margin-right: 8px;"></i>Back</p>
      <div class="info-main">
        <el-form
          :model="addressForm"
          ref="registerForm"
          class="demo-ruleForm"
          style="margin-top: 10px"
        >
          <el-form-item>
            <span slot="label">
               First Name<span>*</span>
            </span>
            <el-input
              placeholder="Enter First Name"
              v-model="addressForm.firstName"
              maxlength="200"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()};"
              @blur="checkNull(addressForm.firstName,'firstNameError')"
              clearable></el-input>
            <div v-if="vail.firstNameError" class="el-form-item__error">Please enter the firstName</div>
          </el-form-item>
          <el-form-item>
             <span slot="label">Last Name<span>*</span>
             </span>
            <el-input
              placeholder="Enter Last Name"
              v-model="addressForm.lastName"
              maxlength="200"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
              @blur="checkNull(addressForm.lastName,'lastNameError')"
              clearable></el-input>
            <div v-if="vail.lastNameError" class="el-form-item__error">Please enter the lastName</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">Business Email<span>*</span>
            </span>
            <el-input
              placeholder="Enter Business Email"
              v-model="addressForm.email"
              maxlength="200"
              oninput="if(value){value=value.toLowerCase()}"
              onblur="if(value){value=value.trim()}"
              @blur="checkNull(addressForm.email,'emailError')"
              clearable></el-input>
            <div v-if="vail.emailError" class="el-form-item__error">{{ vailContent.emailError }}</div>
          </el-form-item>
          <p class="inp-item-select"> Phone<span>*</span></p>
          <el-form-item>

            <div>
              <el-select
                v-model="countryCodeDisplay"
                filterable
                placeholder="+ Country Code"
                @change="codeChange"
              >
                <template slot="empty">
                  <p style="display:none">no data</p>
                </template>
                <el-option
                  v-for="(item, index) in countryArr"
                  :label="item.text"
                  :value="item"
                  :key="index"
                >
                  <span style="float: left">{{ item.text }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                      item.value
                    }}</span>
                </el-option>
              </el-select>
              <el-input
                v-model="addressForm.phone"
                placeholder="Phone"
                @blur="checkNull(addressForm.phone,'phoneError')"
                style="width: 55%;"
              ></el-input>
            </div>
            <div v-if="vail.phoneError" class="el-form-item__error">{{ vailContent.phoneError }}</div>

          </el-form-item>
          <el-form-item label="Type of Store*">
            <el-select
              class="inp-item-select"
              v-model="addressForm.onlineShopType"
              clearable
              placeholder="Select an option"
            >
              <el-option
                v-for="(item, index) in storeType"
                :key="item.textTitle"
                :label="item.textTitle"
                :value="index"
              ></el-option>
            </el-select>
            <div v-if="vail.onlineShopTypeError" class="el-form-item__error">Please select your store type</div>
          </el-form-item>
          <el-form-item>
            <span slot="label">Store Name*</span>
            <el-autocomplete
              class="inp-item-select"
              popper-class="my-autocomplete"
              v-model="addressForm['storeName']"
              :trigger-on-focus="false"
              :fetch-suggestions="getGoogleMap"
              placeholder="Store Name"
              @select="handleSelect">
              <template slot-scope="{ item }">
                <span><img class="sit_img" src="https://shopvidi.oss-cn-beijing.aliyuncs.com/shopvidi-1.4.1/google1.png"
                           alt=""></span>
                <span>{{ item.label }}</span>
                <span style="color:gray;margin-left:2px"> , {{ item.address }}</span>
                <!-- <span class="addr">{{ item.address }}</span> -->
              </template>
            </el-autocomplete>

            <div v-if="vail.storeNameError" class="el-form-item__error">Please fill in the Store Name</div>

          </el-form-item>
          <el-form-item
            v-if="hadAddress || addressForm.storeName"
          >
          <span slot="label">
            Store Address<span v-if="addressForm.onlineShopType === 0  ||addressForm.onlineShopType === 1">*</span>
          </span>
            <el-input
              placeholder="Enter Business Address"
              v-model="addressForm.storeAddress"
              maxlength="200"
              @input="changeBusinessAddress"
              clearable
            ></el-input>
            <div v-if="vail.storeAddressError" class="el-form-item__error">Please fill in Store Address</div>

          </el-form-item>
          <el-row v-if="hadAddress || addressForm.storeName">
            <el-col :span="12" style="">
              <el-form-item>
                <span slot="label">
                  City<span v-if="addressForm.onlineShopType === 0  ||addressForm.onlineShopType === 1">*</span>
                </span>
                <el-input
                  placeholder="Enter City"
                  v-model="addressForm.city"
                  maxlength="40"
                  @input="changeCity"
                  clearable
                ></el-input>
                <div v-if="vail.cityError" class="el-form-item__error">Please fill in City</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">
                  State<span v-if="addressForm.onlineShopType === 0  ||addressForm.onlineShopType === 1">*</span>
                </span>
                <el-input
                  placeholder="Enter State"
                  v-model="addressForm.state"
                  maxlength="40"
                  @input="changeState"
                  clearable
                ></el-input>
                <div v-if="vail.stateError" class="el-form-item__error">Please fill in State</div>

              </el-form-item>
            </el-col>
          </el-row>


          <el-row v-if="hadAddress || addressForm.storeName">
            <el-col :span="12">
              <el-form-item label="Country*">
                <el-select
                  style="width:100%"
                  v-model="addressForm.country"
                  filterable
                  clearable
                  placeholder="Enter Country"
                >
                  <el-option
                    v-for="(item, index) in countryArr"
                    :label="item.text"
                    :value="item.text"
                    :key="index"
                  >
                    <span style="float: left">{{ item.text }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{
                        item.value
                      }}</span>
                  </el-option>
                </el-select>
                <!-- <el-input
                  disabled
                  placeholder="United States of America"
                  v-model="addressForm.country"
                ></el-input> -->
                <div v-if="vail.countryError" class="el-form-item__error">Please select your Country</div>

              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">
                  Zipcode<span v-if="addressForm.onlineShopType === 0  ||addressForm.onlineShopType === 1">*</span>
                </span>
                <el-input
                  placeholder="Enter Zipcode"
                  v-model="addressForm.zipCode"
                  maxlength="5"
                  @input="changeZipCode"
                  clearable
                ></el-input>
                <div v-if="vail.zipCodeError" class="el-form-item__error">Please fill in Zipcode</div>

              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <span slot="label">
             Online Shop URL<span v-if="addressForm.onlineShopType === 2  ||addressForm.onlineShopType === 4">*</span>
            </span>
            <br/>
            <p class="inp-item-cont_p">If you have an online shop or social media, please fill in to help us get to know
              you better</p>
            <el-input
              placeholder="Enter Shop URL"
              v-model="addressForm.shopUrl"
              @input="changeshopUrl"
              clearable
            ></el-input>
            <div v-if="vail.shopUrlError" class="el-form-item__error">Please fill in Online Shop URL</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn" @click="submit">Sumbit</div>

    </div>

  </el-dialog>
</template>

<script>
import {getAction, postAction, downloadStaticFile} from '@/api/manage.js'

export default {
  name: 'createVidirect',
  components: {},
  data() {
    return {
      visible: false,
      hadAddress: false,
      codeObject: '',
      newCountryCode: '',
      emailLimit: '',//数据库配置的邮箱验证
      onlyFlag: false,
      existsError: false,
      addressForm: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        onlineShopType: '',
        storeAddress: '',
        state: '',
        city: '',
        zipCode: '',
        source: '',
        webSite: '',
        isGoogleMap: 0,
        country: 'United States of America',
        referCode: '',
        countryCode: ''
      },
      vail: {
        onlineShopTypeError: false,
        storeNameError: false,
        storeAddressError: false,
        stateError: false,
        cityError: false,
        countryError: false,
        zipCodeError: false,
        shopUrlError: false,
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        phoneError: false,
      },
      vailContent: {
        emailError: '',//邮箱检查错误信息
        phoneError: '',
      },
      options: [],
      optionLabel: [],
      value: [],
      list: [],
      storeType: [
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x.png',
          textTitle: 'Brick & Mortar Store',
          textSubtitle: 'I sell from my own retail storefront.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%281%29.png',
          textTitle: 'Brick & Mortar and Online Store',
          textSubtitle: 'I sell from both retail stores and online stores.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%282%29.png',
          textTitle: 'Online Botique Store',
          textSubtitle: 'I only sell from my own unique website.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%283%29.png',
          textTitle: 'Pop-up Store',
          textSubtitle:
            'I sell from a shared marketplace as a vendor, or at events.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%284%29.png',
          textTitle: 'Social Media',
          textSubtitle: 'I only sell products on other channels'
        }
      ],
      countryArr: JSON.parse(localStorage.getItem('allCountry')) || [],
      countryCodeDisplay: ''
    }
  },
  created() {
    this.loadConfigurationEmal()
    this.getPhoneAndCountry()
  },
  methods: {
    submit() {
      //初始化
      for (let vailKey in this.vail) {
        this.vail[vailKey] = false
      }

      //用户信息
      let typeMapTmp = new Map([['firstName', 'firstNameError'], ['lastName', 'lastNameError'], ['email', 'emailError'], ['phone', 'phoneError']])
      typeMapTmp.forEach((v, k) => {
        this.checkNull(this.addressForm[k], v)
      })

      if (this.addressForm.onlineShopType === '') {
        this.vail.onlineShopTypeError = true
      }
      if (!this.addressForm.storeName) {
        this.vail.storeNameError = true
      }
      if (this.addressForm.onlineShopType === 0 || this.addressForm.onlineShopType === 1) {
        if (!this.addressForm.storeAddress) {
          this.vail.storeAddressError = true
        }
        if (!this.addressForm.state) {
          this.vail.stateError = true
        }
        if (!this.addressForm.city) {
          this.vail.cityError = true
        }
        if (!this.addressForm.zipCode) {
          this.vail.zipCodeError = true
        }
      }
      // if (!this.addressForm.country) {
      //   this.vail.countryError = true
      // }
      if (this.addressForm.onlineShopType === 2 || this.addressForm.onlineShopType === 4) {
        if (!this.addressForm.shopUrl) {
          this.vail.shopUrlError = true
        }
      }

      if (this.addressForm.country) {
        this.addressForm.countryCode = this.getCountryCode(this.addressForm.country)
      }
      setTimeout(this.regRetailer, 500)

    },
    regRetailer() {
      let that = this
      for (let vailKey in that.vail) {
        if (that.vail[vailKey]) {
          that.existsError = true
          return
        }
      }

      postAction('/sys/user/register-retailer', this.addressForm).then((res) => {
        if (res.success) {
          this.closeDia()
          //this.$refs['registerForm'].resetFields();
          for (let key in this.addressForm) {
            if (key !== 'country') {
              this.addressForm[key] = ''
            }
          }

        } else {
          this.$message.warning(res.message)
        }
      })
    },
    checkNull(vle, propertiy) {
      this.vail[propertiy] = false

      switch (propertiy) {
        case 'emailError':
          this.checkEmail(vle, propertiy)
          break
        case 'phoneError':
          this.checkPhone(vle, propertiy)
          break
        default:
          if (!vle) {
            this.vail[propertiy] = true
          }
          break
      }
    },
    getCountryCode(t) {
      let ret = ''
      this.countryArr.forEach(e => {
        if (e.text === t) {
          this.countryCodeDisplay = e.value
          ret = e.desc.split(':')[0]
          return ret
        }
      })
      return ret
      /* if (t == 'United States of America') {
              return 'US'
            } else if (t == 'Australia') {
              return 'AU'
            } else if (t == 'Canada') {
              return 'CA'
            } else if (t == 'United Kingdom') {
              return 'UK'
            } */
    },
    loadConfigurationEmal() {
      getAction('/simple/configuration?key=sign_up_email_limit').then(response => {
        if (response.success) {
          if (response.result.configurationValue) {
            if (response.result.configurationValue !== '') {
              this.emailLimit = response.result.configurationValue
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 检查邮箱
     */
    checkEmail(value, propertiy) {
      if (value) {
        value = value.trim()
      }

      if (!value) {
        this.vail[propertiy] = true
        this.vailContent['emailError'] = 'Please enter the email'
        return
      }
      let reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      //  先判断格式是否正确，格式不正确则直接返回
      if (reg.test(value)) {
        //  判断我们是否有邮箱验证，
        if (this.emailLimit) {
          let index = value.indexOf('@')
          if (index > -1) {
            const emailSuffix = value.substring(index, value.length)
            if (this.emailLimit.indexOf(emailSuffix) > -1) {
              this.vail[propertiy] = true
              this.vailContent['emailError'] = 'Please enter your email, if you cannot register, please contact customer service'
              return
            }
          }
          // callback(new Error('Please enter the correct email address'))
        }
        this.checkOnlyEmail(value)

        let that = this
        setTimeout(function () {
          if (that.onlyFlag) {
            that.vail[propertiy] = true
            that.vailContent['emailError'] = 'Email registered'
          }
        }, 300)
      } else {
        this.vail[propertiy] = true
        this.vailContent['emailError'] = 'Please enter the correct email address'
      }
    },
    async checkOnlyEmail(email) {
      let res = await getAction('/sys/user/checkOnlyUser', {
        email: email
      })
      // true ：表示存在
      this.onlyFlag = !res.success
    },
    checkPhone(value, propertiy) {

      let phone = this.addressForm.phone
      let code = this.addressForm.countryCode
      if (code == '') {
        this.vail[propertiy] = true
        this.vailContent['phoneError'] = 'Please enter the countryCode'
      }
      if (phone == '') {
        this.vail[propertiy] = true
        this.vailContent['phoneError'] = 'Please enter the phone'
        return
      }
      // let isUs = phone.length==10&&this.usCode.indexOf(code.split('+')[1])>=0
      // let isGB = (phone.length==9&&code=='+7')||(phone.length==8&&code=='+07');

      // 如果是美国或者英国则判断后面手机号的长度
      if (code === 'US' || code === 'UK' || code === 'CA') {
        if (phone.length !== 10) {
          this.vail[propertiy] = true
          this.vailContent['phoneError'] = 'Please enter the correct number'
        }
      }
      if (code === 'AU') {
        if (phone.length !== 9) {
          this.vail[propertiy] = true
          this.vailContent['phoneError'] = 'Please enter the correct number'
        }
      }

    },
    showCreateDialog() {
      this.visible = true

      // 清空默认值
      for (let key in this.addressForm) {
        if (key !== 'country') {
          this.addressForm[key] = ''
        } else {
          this.addressForm[key] = 'United States of America'
          this.countryCodeDisplay = ''
        }
      }
      for (let vailKey in this.vail) {
        this.vail[vailKey] = false
      }

    },
    closeDia() {
      this.visible = false
      this.$parent.loadData()
    },
    // 获取国家、手机号配置信息
    getPhoneAndCountry() {
      getAction('/sys/dict/getDictItems/reg-country-config').then(response => {
        if (response.success) {
          if (response.result) {
            this.countryArr = response.result
            localStorage.setItem('allCountry', JSON.stringify(response.result))
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleSelect(object) {
      this.addressForm.isGoogleMap = 1
      getAction('/register/place/detail', {'place_id': object.placeId}).then((res) => {
        if (res.success) {
          this.addressForm.storeName = res.result.storeName
          this.addressForm.storeAddress = res.result.address
          this.addressForm.state = res.result.state
          this.addressForm.city = res.result.city
          this.addressForm.zipCode = res.result.postCode
        }
      })
    },
    getGoogleMap(query, cb) {
      let countryName = this.$ls.get('userInfo').countryCode
      getAction('/register/place/autocomplete', {'keyWords': query, 'countryCode': countryName}).then((res) => {
        if (res.success) {
          this.options = []
          if (res.result) {
            for (let i = 0; i < res.result.length; i++) {
              let optionValue = {
                label: res.result[i].structured_formatting.main_text,
                value: res.result[i].structured_formatting.main_text,
                address: res.result[i].structured_formatting.secondary_text,
                placeId: res.result[i].place_id
              }
              this.options.push(optionValue)
            }
            cb(this.options)
          } else {
            this.options = []
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    changeBusinessAddress(value) {
      this.addressForm.storeAddress = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    changeCity(value) {
      this.addressForm.city = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(/[\d]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    changeState(value) {
      this.addressForm.state = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(/[\d]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    changeshopUrl(value) {
      this.addressForm.shopUrl = value
        .replace(/[\u4e00-\u9fa5]/g, '')
        .replace(
          /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
          ''
        )
    },
    changeZipCode(value) {
      this.addressForm.zipCode = value.replace(/[^\d]/g, '')
    },
    codeChange(country) {
      const numberValue = country.desc.split(':')
      this.addressForm.countryCode = numberValue[0]
      this.addressForm.country = country.text
      this.countryCodeDisplay = country.value
    }

  }

}

</script>


<style lang="less" scoped>
.create-account {
  padding: 20px;

  p:nth-child(1) {
    cursor: pointer;
    font-weight: bold;
  }

  .btn {
    background-color: #262b2f;
    color: #FFFFFF;
    cursor: pointer;
    line-height: 40px;
    height: 40px;
    text-align: center;
    width: 150px;
    font-weight: 500;
    margin: 0 auto;
  }
}

.inp-item-select {
  width: 100% !important;
}

.info-main {
  .store-type-outline {
    border: 1px solid #262b2f !important;
  }

  .store-type {
    cursor: pointer;
    width: 480px;
    height: 80px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #e1e1e1;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .stoe-type-img {
      width: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .store-type1-icon {
      width: 45.65px;
      height: 41.21px;
    }

    .store-type2-icon {
      width: 58.84px;
      height: 46.13px;
    }

    .store-type3-icon {
      width: 51.53px;
      height: 42.06px;
    }

    .store-type4-icon {
      width: 50.08px;
      height: 48.55px;
    }

    .store-type5-icon {
      width: 48px;
      height: 42px;
    }

    .store-type-text {
      .text-title {
        font-size: 14px;
        font-weight: 800;
      }

      .text-subtitle {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }
    }
  }

  .inp-item-cont {
    width: 480px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vidirect/create-vidirect.vue